<script>
  import { authUrl } from "../const";
  import {auth} from '../auth'
</script>

{#if $auth.loginRedir}
  <div>
    Attempting to login, you will be redirected to <a href='{$auth.loginRedir}'>here</a>.
  </div>
{:else}
  <div>
    You must <a
      href="https://{authUrl}/login?d={window.location
        .hostname}&r={window.location.href}">login</a
    > to use this site.
  </div>
{/if}

<style>
  div {
    background-color: #fefefe;
    border: 2px solid black;
    border-radius: 8px;
    width: 350px;
    padding: 20px;
    margin: auto;
    margin-top: 50px;
    text-align: center;
    font-size: 14pt;
  }
</style>
